module.exports = __webpack_public_path__ + "static/img/puka.684b3d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/puka.png
// module id = 7RYl
// module chunks = 1